module.exports = __webpack_public_path__ + "static/media/bottlings8.118665cd.jpg";